import * as Sentry from '@sentry/react'

export function init() {
  Sentry.init({
    dsn: import.meta.env.VITE_ADMIN_SENTRY_DSN,
    ignoreErrors: [
      // We don't need to know about 401s since we expect them
      'Received status code 401'
    ],
    integrations: [
      Sentry.captureConsoleIntegration({
        levels: ['error']
      }),
      Sentry.feedbackIntegration({
        autoInject: false,
        showName: false,
        showEmail: false,
        showBranding: false
      })
    ],
    environment: import.meta.env.VITE_STAGE
  })
}
